module.exports = __webpack_public_path__ + "static/media/arrowVector.c8338504.svg";